import { ChangeEvent } from 'react';

import { Box, InputBase, Stack, useTheme } from '@mui/material';
import { useField } from 'formik';

import ValidateButton from '../FormikComponents/PhoneNumberField/components/ValidateButton';

interface InputWithSearchProps {
    label: string;
    placeholder: string;
    onSearch: (value: any, name: string) => void;
    searchText: string;
    fieldName: string;
    maskedValue?: string;
    clearMaskedValue?: () => void;
    onChange?: (e: ChangeEvent<unknown>) => void;
    dataTestId?: string;
    disabled?: boolean;
}

export const InputWithSearch = ({
    label,
    placeholder,
    onSearch,
    searchText,
    fieldName,
    maskedValue,
    disabled,
    onChange,
    clearMaskedValue,
    dataTestId = `${fieldName}-input`,
    ...props
}: InputWithSearchProps) => {
    const [field, meta] = useField(fieldName);
    const { palette } = useTheme();
    const bgColour = meta.touched && meta.error ? palette.error.main : palette.border.light;

    return (
        <Stack sx={{ position: 'relative' }}>
            <label className="mb-5 font-bold">{label}</label>
            <Box
                className={`search-input-box ${meta.touched && meta.error ? 'input-error' : ''}`}
                display="flex"
                justifyContent="space-between"
            >
                <InputBase
                    {...field}
                    {...props}
                    slotProps={{
                        input: {
                            'data-testid': dataTestId,
                        },
                    }}
                    inputProps={{
                        'data-testid': dataTestId,
                    }}
                    onChange={(e) => {
                        if (onChange) {
                            onChange(e);
                        }
                        field.onChange(e);
                    }}
                    value={maskedValue || field.value}
                    onClick={clearMaskedValue && clearMaskedValue}
                    placeholder={placeholder}
                    autoComplete="off"
                    className="search-input-base"
                    disabled={disabled}
                />

                <ValidateButton
                    onClick={() => {
                        return onSearch(field.value, field.name);
                    }}
                    disabled={disabled}
                    searchText={searchText}
                    dataTestId={field.name}
                    sx={{
                        backgroundColor: bgColour,
                    }}
                />
            </Box>
            {meta.touched && meta.error && (
                <label className="input-base-field-error">{meta.error}</label>
            )}
        </Stack>
    );
};
